__turbopack_context__.v({
  "arrow": "ConnectionsConvertToManagedModal-module__4nu3yW__arrow",
  "body": "ConnectionsConvertToManagedModal-module__4nu3yW__body",
  "checkList": "ConnectionsConvertToManagedModal-module__4nu3yW__checkList",
  "header": "ConnectionsConvertToManagedModal-module__4nu3yW__header",
  "preview": "ConnectionsConvertToManagedModal-module__4nu3yW__preview",
  "section": "ConnectionsConvertToManagedModal-module__4nu3yW__section",
  "shareBack": "ConnectionsConvertToManagedModal-module__4nu3yW__shareBack",
});
